import React, { useState, useEffect, useRef } from "react";
import "./ChatBot.css";
import "./Chatbox.css";
import validator from "validator";
import axios from 'axios'
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import send from "../../../Assets/images/chatbotimages/send.png";
import { useNavigate } from "react-router-dom";

function Chatbox() {
  const [saloncity, setSaloncity] = useState([]);
  const [salonarea, setSalonarea] = useState([]);
  const [salonCategories, setSalonCategories] = useState([]);
  const [visibility, setVisibility] = useState("visible");
  const [padding, setPadding] = useState("0px");
  const [activeAccordion, setActiveAccordion] = useState(true);
  const [children, setChildren] = useState([]);
  const [name, setName] = useState("");
  const [priya, setPriya] = useState([]);
  const [inputType, setInputType] = useState("text");
  const [salons, setSalons] = useState([]);
  const category = [];
  const city = [];
  const area = [];
  const elementRef = useRef(null);
  const [number, setNumber] = useState(null);
  const [ISTTime, setISTTime] = useState('');
  const navigate = useNavigate();

  const getISTTime = () => {
    const currentDate = new Date();
    const currentHour = currentDate.getHours();
    const currentMinute = currentDate.getMinutes();
    const currentSecond = currentDate.getSeconds();
    const formattedTime = `${currentHour}:${currentMinute}:${currentSecond}`;
    return formattedTime
  };

  const scrollToElement = () => {
    if (elementRef.current) {
      elementRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://trakky.in:8000/salons/city/");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data3 = await response.json();
        setSalons(data3.payload);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch("https://trakky.in:8000/salons/category/");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        // Extract unique category names
        const uniqueCategories = [...new Set(data.map(item => item.category_name))];
        setSalonCategories(uniqueCategories);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    setSaloncity(salons.map((item) => item.name));
    setSalonarea(salons.map((item) => item.area_names));
  }, [salons]);

  function sendNameHandler() {
    if (!validator.isAlpha(name.trim())) {
      alert("Please enter only alphabetic characters for your name.");
      return;
    }
    setInputType("number");
    const newChild = {
      time: getISTTime(),
      user: name,
      us: `Hi ${name}! please provide your number for better experiance?`,
      next: sendNumberHandler,
    };
    setPriya((prev) => [...prev, newChild]);
  }

  function sendNumberHandler() {
    if (typeof number === "string" && number.trim() !== "") {
      if (validator.isMobilePhone(number, "en-IN")) {
        setVisibility("hidden");
        const newChild = {
          quote: "In Which city are you interested in booking a salon?",
          heading: "Select city",
          user: number,
          us: saloncity,
          next: areaHandler,
        };
        setChildren((prevChildren) => [...prevChildren, newChild]);
        setActiveAccordion(0);
        data1.push(newChild);
      } else {
        alert("Please enter a valid mobile number");
      }
    } else {
      alert("Please enter a valid mobile number");
    }
  }

  function areaHandler(e) {
    setPadding("45px");
    scrollToElement();
    let selectedCity = e.target.id;
    let area = salons.map((item) => {
      if (item.name === selectedCity) {
        return item.area_names;
      }
    });
    let filtarea = area.filter((item) => {
      if (item !== undefined) {
        return item;
      }
    });
    let newChild = {
      quote: "Explore the beauty in every corner of your city",
      heading: "Select Area",
      user: e.target.id,
      us: filtarea[0],
      next: CategoryHandler,
    };
    setChildren((prevChildren) => [...prevChildren, newChild]);
    data1.push(newChild);
    setActiveAccordion(data1.length - 1);
    city.push(selectedCity);
  }

  function CategoryHandler(e) {
    scrollToElement();
    let newChild = {
      quote: "What service are you looking for?",
      heading: "Select Category",
      user: e.target.id,
      us: salonCategories, // Using fetched categories instead of static data
      next: SegmentHandler,
    };
    setChildren((prevChildren) => [...prevChildren, newChild]);
    area.push(newChild.user);
    data1.push(newChild);
    setActiveAccordion(data1.length - 1);
  }

  function SegmentHandler(e) {
    category.push(e.target.id);
    scrollToElement();
    let newChild = {
      quote: "Make an instant reservation or explore benefits",
      heading: "Select an option",
      user: e.target.id,
      us: ["Book an appointment", "Benefits for you only!"],
      next: segmentHanlder2,
    };
    setChildren((prevChildren) => [...prevChildren, newChild]);
    data1.push(newChild);
    setActiveAccordion(data1.length - 1);
  }

  function segmentHanlder2(e) {
    scrollToElement();
    if (e.target.id === "Book an appointment") {
      let lastindexCity = city.length - 1;
      let lastindexArea = area.length - 1;

      // Navigate to offer page with the selected city and area
      navigate(`/${city[lastindexCity].toLowerCase()}/offerpage`, {
        state: {
          selectedCity: city[lastindexCity],
          selectedArea: area[lastindexArea],
          scrollToSalons: true
        }
      });

    } else {
      let newChild = {
        quote:
          "Explore offers on whatsApp or book an appointment at top rated salons",
        heading: "Select an option",
        user: e.target.id,
        us: [
          <span
            onClick={redirectToWhatsApp}
            style={{ display: "flex", width: "100%" }}
          >
            Get offers
          </span>,
          "Top rated salons",
        ],
        next: next,
      };
      setChildren((prevChildren) => [...prevChildren, newChild]);
      data1.push(newChild);
      setActiveAccordion(data1.length - 1);
    }
  }

  function next(e) {
    scrollToElement();
    if (e.target.id === "select another city & area") {
      let newChild = {
        quote: "In Which city are you interested in booking a salon?",
        heading: "Select City",
        user: e.target.id,
        us: saloncity,
        next: areaHandler,
      };
      setChildren((prevChildren) => [...prevChildren, newChild]);
      data1.push(newChild);
      setActiveAccordion(data1.length - 1);
    } else if (e.target.id === "Top rated salons") {
      let lastindexCity = city.length - 1;
      let newcity = city[lastindexCity];
      let link = `https://trakky.in/${newcity}/topratedsalons`;
      let newChild = {
        quote:
          "Did you get your salon at your preffered location or you want to explore more",
        heading: "Select an option",
        user: e.target.id,
        us: [
          <a href={link} target="_blank">
            Click to get top rated salons in {newcity}
          </a>,
          "Select another city & area",
        ],
        next: next2,
      };
      setChildren((prevChildren) => [...prevChildren, newChild]);
      data1.push(newChild);
      setActiveAccordion(data1.length - 1);
    }
  }

  function next2(e) {
    scrollToElement();
    if (e.target.id === "Select another city & area") {
      let newChild = {
        quote: "In Which city are you interested in booking a salon?",
        heading: "Select City",
        user: e.target.id,
        us: saloncity,
        next: areaHandler,
      };
      setChildren((prevChildren) => [...prevChildren, newChild]);
      data1.push(newChild);
      setActiveAccordion(data1.length - 1);
      axios.post("https://trakky.in:8000/api/chatdata/", {
        children: data1,
        number: number,
        name: name,
      })
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  function handleKeyPress(e) {
    if (e.key === "Enter") {
      sendNameHandler();
    }
  }

  function redirectToWhatsApp() {
    let categorylastindex = category.length - 1;
    let arealastindex = area.length - 1;
    let citylastindex = city.length - 1;

    if (category.length === 0 || area.length === 0 || city.length === 0) {
      console.error("Error: Data arrays are empty.");
      return;
    }

    const phoneNumber = "+91 6355167304";
    const defaultMessage = `Hello! I'm in ${city[citylastindex]} and looking for offers at ${area[arealastindex]} for ${category[categorylastindex]} services.`;
    const encodedMessage = encodeURIComponent(defaultMessage);
    const whatsappURL = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;
    window.location.href = whatsappURL;
  }

  const data1 = [];

  return (
    <div>
      <div className="chat-box-div-2">
        <div className="inputName_chatbox"></div>
        <div
          className="chatbot_greet"
          style={{
            paddingLeft: "8px",
            paddingTop: padding,
            flexDirection: "column",
          }}
        >
          <p className="bot-text" style={{ width: "200px" }}>
            <span
              style={{
                fontSize: "12px",
                color: "#512DC8",
                marginBottom: "10px",
              }}
            >
              Priya
            </span>
            <br />
            <span>Hello! What is your good name?</span>
          </p>
          {priya.map((item) => {
            return (
              <>
                <div className="chatbot_parent1">
                  <div className="chatbot_user">{item.user}</div>
                </div>
                <p className="bot-text" style={{ width: "200px" }}>
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#512DC8",
                      marginBottom: "10px",
                    }}
                  >
                    Priya
                  </span>
                  <br />
                  <span>{item.us}</span>
                </p>
              </>
            );
          })}
        </div>
        <div className="chatbot_parent">
          {children.map((child, index) => (
            <>
              <div className="chatbot_parent1">
                <div key={index} className="chatbot_user">
                  {child.user}
                </div>
              </div>
              <div className="chatbot_parent2">
                <div key={index} className="chatbot_us">
                  <Accordion
                    expanded={activeAccordion === index}
                    onChange={() => setActiveAccordion(index)}
                  >
                    <AccordionSummary
                      aria-controls="panel-content"
                      id="panel-header"
                    >
                      <p style={{ padding: "10px 0px" }}>{child.quote}</p>
                      <p className="chatbox_heading">
                        {child.heading} <ExpandMoreIcon />
                      </p>
                    </AccordionSummary>
                    <AccordionDetails>
                      <ul className="chatbot_ul">
                        {child.us.map((item) => (
                          <li key={item} onClick={child.next} id={item}>
                            {item}
                          </li>
                        ))}
                      </ul>
                    </AccordionDetails>
                  </Accordion>
                </div>
              </div>
            </>
          ))}
        </div>
        <div
          className="chatbox_input"
          style={{ visibility: visibility }}
          ref={elementRef}
        >
          <input
            className="chatbot_input"
            type={inputType}
            value={inputType === "text" ? name : number}
            onChange={
              inputType === "text"
                ? (e) => setName(e.target.value)
                : (e) => setNumber(e.target.value)
            }
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                inputType === "text" ? sendNameHandler() : sendNumberHandler();
              }
            }}
          />
          <img
            src={send}
            alt=""
            className="send_button_chatbox"
            onClick={inputType === "text" ? sendNameHandler : sendNumberHandler}
          />
        </div>
      </div>
    </div>
  );
}

export default Chatbox;